







































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    createrange=[];
    merchantTableLoading = false;
    merchantData = []
    allcount = 0;
    get prox() {
        return new proxy.AgentServiceProxy();
    }
    columns1 = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '商户号',
      key: 'mid',
    },
    {
      title: '商户名',
      key: 'merchantName'
    },
    {
      title: '余额',
      slot: 'balance'
    },
    {
      title: '总金额',
      slot: 'totalMoney'
    },
    {
      title: '成交金额',
      slot: 'bargainMoney'
    },
    {
      title: '成功率',
      slot: 'bargainRate'
    },
    {
      title: '代理费',
      slot: 'agentMoney'
    },
  ]

  options = {
    shortcuts: [
      {
        text: '今天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
          return [start, end]
        }
      },
      {
        text: '昨天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime());
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24);
          return [start, end]
        }
      },
      {
        text: '三天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 2);
          return [start, end]
        }
      },
      {
        text: '一周',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 6);
          return [start, end]
        }
      },
      {
        text: '一个月',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 29);
          return [start, end]
        }
      }
    ]
  }
    merchantGet() {
    this.merchantTableLoading = true;
    this.prox.agentMerchantSummary(this.createrange[0], this.createrange[1],this.id).then(x => {
      x.forEach(t => {
        if (t.bargainRate >= 0 && t.bargainRate <= 10) {
          this.$set(t, 'fontColor', 'red')
        } else if (t.bargainRate >= 10 && t.bargainRate <= 50) {
          this.$set(t, 'fontColor', 'gold')
        } else if (t.bargainRate > 50 && t.bargainRate < 100) {
          this.$set(t, 'fontColor', 'green')
        } else {
          this.$set(t, 'fontColor', 'blue')
        }
      })
      this.merchantData = x;
      this.allcount = this.merchantData.length;
      this.merchantTableLoading = false;
    })
  }
    save() {
        this.$emit("input", false);
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.createrange = [
            new Date(new Date(new Date().toLocaleDateString()).getTime()),
            new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
            ];
            this.merchantGet()
        }
    }

    roleRule = {};
}
